import { InMemoryCache } from '@apollo/client';

export const cacheConfig = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        basket: {
          merge: false,
        },
      },
    },
    Subscription: {
      fields: {
        appointmentEvent: {
          merge: (_, incoming) => incoming,
        },
      },
    },
    Basket: {
      fields: {
        selectedQuotes: {
          merge: false,
        },
        quotes: {
          merge: false,
        },
        basketStatus: {
          merge: false,
        },
        details: {
          merge: false,
        },
      },
    },
    BasketDetails: {
      keyFields: false,
      fields: {
        supplyAddress: {
          merge: false,
        },
      },
    },
    BasketStatus: {
      keyFields: false,
      fields: {
        unavailableStatuses: {
          merge: false,
        },
      },
    },
    Quote: {
      keyFields: false,
      fields: {
        product: {
          merge: false,
        },
        status: {
          merge: false,
        },
        totalMonthlyCost: {
          merge: false,
        },
        discounts: {
          merge: false,
        },
        allProductCharges: {
          merge: false,
        },
      },
    },
    QuoteStatus: {
      keyFields: false,
      merge: false,
    },
    Product: {
      keyFields: false,
      fields: {
        details: {
          merge: false,
        },
      },
    },
    Charge: {
      keyFields: false,
      merge: false,
    },
    ChargeAmount: {
      keyFields: false,
      merge: false,
    },
    Discount: {
      keyFields: false,
      merge: false,
    },
    QuoteRequirement: {
      keyFields: false,
      merge: false,
    },
    InsuranceDocument: {
      keyFields: false,
      merge: false,
    },
    StateChangedEvent: {
      keyFields: false,
      merge: false,
      fields: {
        timestamp: {
          merge: false,
        },
        key: {
          merge: false,
        },
        data: {
          merge: false,
        },
      },
    },
    HeartbeatEvent: {
      keyFields: false,
      merge: false,
    },
    AppointmentInteractionEventFocus: {
      keyFields: false,
      merge: false,
    },
    AppointmentInteractionEventScrolling: {
      keyFields: false,
      merge: false,
    },
    ParticipantLeftAppointmentEvent: {
      keyFields: false,
      merge: false,
    },
    AttributionDetails: {
      keyFields: false,
      merge: false,
    },
    Assistant: {
      keyFields: false,
      merge: false,
    },
    Referrer: {
      keyFields: false,
      merge: false,
    },
    SupportingPartner: {
      keyFields: false,
      merge: false,
    },
    Partner: {
      keyFields: false,
      merge: false,
    },
    PartnerReferrer: {
      keyFields: false,
      merge: false,
    },
    Sales: {
      keyFields: false,
      merge: false,
    },
    Customer: {
      keyFields: false,
      merge: false,
    },
    Affiliate: {
      keyFields: false,
      merge: false,
    },
    Uswitch: {
      keyFields: false,
      merge: false,
    },
    Connector: {
      keyFields: false,
      merge: false,
    },
    MobileTariffs: {
      keyFields: false,
      fields: {
        discounts: {
          merge: false,
        },
        tariffs: {
          merge: false,
        },
      },
    },
    MobileTariff: {
      fields: {
        discounts: {
          merge: false,
        },
      },
    },
    QualifiedDiscount: {
      keyFields: false,
      merge: false,
    },
  },
});
